let queuedJobs = [];
const listeners = new Set();

const snapshot = () => ({
  pendingCount: queuedJobs.length,
  jobs: [...queuedJobs],
  isPrinting: queuedJobs.length > 0,
  lastUpdated: Date.now(),
});

const notify = () => {
  const state = snapshot();
  listeners.forEach((listener) => {
    try {
      listener(state);
    } catch (error) {
      console.warn('[PrintQueueMonitor] Listener failed:', error?.message || error);
    }
  });
};

export const getPrintQueueState = () => snapshot();

export const subscribeToPrintQueue = (listener) => {
  if (typeof listener !== 'function') {
    return () => {};
  }

  listeners.add(listener);
  listener(snapshot());

  return () => {
    listeners.delete(listener);
  };
};

export const registerPrintJob = (label = 'print') => {
  const jobId = `${label}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  queuedJobs = [
    ...queuedJobs,
    {
      id: jobId,
      label,
      queuedAt: Date.now(),
    },
  ];
  notify();
  return jobId;
};

export const completePrintJob = (jobId) => {
  const nextJobs = queuedJobs.filter((job) => job.id !== jobId);
  if (nextJobs.length === queuedJobs.length) {
    return;
  }

  queuedJobs = nextJobs;
  notify();
};

